import get from 'lodash/get';
import { i18n_t as $t } from '@/utils/i18n';

const lockSavedFilters = ['All Replays'];

export const REPLAY_LIBRARY = 'replaylibrary';

export const SAVED_VIEWS_TYPES = {
    REPLAY_LIBRARY,
};

export const formatSavedFilter = (savedFilter) => {
    const locked = lockSavedFilters.includes(savedFilter?.name) && isOwnedByPendo(savedFilter);

    let { name, description } = savedFilter;

    if (locked && name === 'All Replays') {
        name = $t('Last 7 days');
        description = $t(
            'savedFiltersUtils.This default view contains all replays captured from the last 7 days (and today).',
        );
    }

    return {
        ...savedFilter,
        filters: mapFilters(get(savedFilter, 'filters', [])),
        locked,
        name,
        description,
    };
};

export function mapFilters (filters = []) {
    if (!filters) return {};

    const map = {};
    filters.forEach(({ type, value }) => {
        map[type] = value;
    });

    return map;
}

export function unmapFilters (filters = {}) {
    if (!filters) return [];

    return Object.entries(filters).map(([type, value]) => ({ type, value }));
}

export function isOwnedByPendo (savedFilter) {
    return get(savedFilter, 'createdByUser.username') === '--system-user--';
}

export function isOwnedByCurrentUser (savedFilter, currentUserId) {
    return get(savedFilter, 'createdByUser.id') === currentUserId;
}

export function normalizedOwner (savedFilter) {
    return isOwnedByPendo(savedFilter) ? 'Pendo' : savedFilter.createdByUser.username;
}
